import BaseModel from "../base_model.js";

import UploadGalleryImageUseCase from "../../use_cases/assets/gallery_images/upload_gallery_image_use_case.js";

class RawProjectImageModel extends BaseModel {

  rawNestedFormFields(item = undefined) {
    return [
      {
        name: "galleryImage",
        type: "image",
        weight: 12,
        allowSelfLoad: false,
        allowDelete: false,
        foreignKey: "galleryImageId",
        allowAutoDeleteOnError: true,
        uploader: (file) => {
          return UploadGalleryImageUseCase.execute(file).then(result => {
            return result.data.galleryImage;
          })
        }
      },
    ]
  }

  i18nScope() {
    return "model.projects.project_image";
  }

}
const ProjectImageModel = new RawProjectImageModel();

export { RawProjectImageModel, ProjectImageModel }

